import React, { forwardRef, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';

const VerifyButton = forwardRef((props, ref) => {
  const [buttonHovered, setButtonHovered] = useState(false);

  const handleMouseEnter = () => {
    setButtonHovered(true);
  };

  const handleMouseLeave = () => {
    setButtonHovered(false);
  };

  const { onClick, isVerified, isLoading } = props;
  return (
    isVerified
      ? (
        <div
          className={cn('smarty-tag-check', 'btn', 'btn-success')}
          onClick={onClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          ref={ref}
        >
          ✓
          <span className="verifyText">
            { buttonHovered ? 'Undo' : 'Verified' }
          </span>
        </div>
      )
      : (
        <div className={cn('smarty-tag-check', 'btn', 'btn-primary')} onClick={onClick} ref={ref}>
          {
            isLoading ? (
              <div title="Loading..." className={cn('smarty-dots')} />
            ) : 'Verify'
          }
        </div>
      )
  );
});

VerifyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isVerified: PropTypes.bool,
  isLoading: PropTypes.bool,
};

VerifyButton.defaultProps = {
  isVerified: false,
  isLoading: true,
};

export default VerifyButton;
